import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CpMarketplaceApiService } from '../../../services/cp-marketplace-api.service';
import { SharedDataService } from '../../../services/shared-data.service';
import { ISSUER_MESSAGES } from 'src/app/messages';
import { AllDocsAdditionalData } from 'appRootPath/models/commercial-papers.model';

@Component({
  selector: 'app-mcf-additional-data',
  templateUrl: './mcf-additional-data.component.html',
  styleUrls: ['./mcf-additional-data.component.scss']
})

export class McfAdditionalDataComponent implements OnInit {
  @Input() issueId;
  mcfAdditionalDataForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private apiService: CpMarketplaceApiService,
    private sharedData: SharedDataService
  ) { }

  ngOnInit() {
    this.mcfAdditionalDataForm = this.fb.group({
      answer: false
    });
  }

  saveSectionA() {
    const mcfAdditionalData = {
      issue: this.issueId,
      master_creation_form: {
        show_section_a: this.mcfAdditionalDataForm.value.answer
      }
    };

    this.apiService.postAdditionalData(mcfAdditionalData).
      subscribe((res: AllDocsAdditionalData) => {
        if (res.id) {
          this.toastr.success(ISSUER_MESSAGES.MCF_ADDN_DATA);
          this.activeModal.close(res.master_creation_form);
        }
      });
  }
}
